export const COMBOBOX_TAG_NAME = "combobox" as const;

export const COMBOBOX_ITEM_TAG_NAME = "combobox-item" as const;

export const COMBOBOX_GROUP_TAG_NAME = "combobox-group" as const;
